import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { faFileUpload, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FilePondOptions } from 'filepond';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, tap } from 'rxjs';

import { PATH } from '@app/constants';
import { Developer } from '@app/interfaces';
import { DeveloperService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';

@Component({
  selector: 'mnf-authentication-first-screen',
  templateUrl: './authentication-first-screen.component.html',
  styleUrls: ['./authentication-first-screen.component.scss']
})
export class AuthenticationFirstScreenComponent implements OnInit {

  @ViewChild('pondBrochure') pondBrochure: any;

  @Output() form = new EventEmitter();
  @Input() set user(u: Developer) {
    this.developer = u;
  }

  /** Inicializar formulario */
  firstFormDev: FormGroup;

  /** Variable global de developer */
  developer: Developer;

  /** Variable global email */
  email: string;

  iconReUpload = faFileUpload;
  iconX = faXmark;

  /** Documentos */
  brochureDefined: string;
  brochureFile: string;
  brochureTmpFile: File;
  brochureName = '';

  /** Formato de archivo a aceptar */
  acceptableFiles = [
    'image/png',
    'image/jpeg',
    'application/pdf',
    'application/msword',
    'application/pdf',
    'application/xml',
    'image/webp',
    'application/zip',
    'application/x-zip-compressed'
  ];

  brochureOptions: FilePondOptions = {
    labelIdle: '* Brochure de ventas o proyecto',
    labelFileTypeNotAllowed: 'Tipo de archivo no válido',
    labelFileSizeNotAvailable: 'Tamaño máximo de 15 mb',
    chunkSize: 15728640,
    acceptedFileTypes: this.acceptableFiles
  }

  brochureFiles: FilePondOptions['files'] = [];

  constructor(
    private devServ: DeveloperService,
    private toastServ: ToastrService,
    private modalServ: ModalService,
    private router: Router
  ) {}

  ngOnInit(): void {
    /** Asignar brochure */
    this.brochureFile = this.developer?.developer?.info?.brochure;

    /** Asignar email */
    this.email = this.developer.email;

    /** Iniciar formulario cuando carge el componente */
    this.firstFormDev = new FormGroup({
      name: new FormControl(this.developer?.name || '', [Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(30)])]),
      fatherSurname: new FormControl(this.developer?.fatherSurname || '', [Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(30)])]),
      motherSurname: new FormControl(this.developer?.motherSurname || '', [Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(30)])]),
      phone: new FormControl(this.developer?.phone || '', [Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(15)])])
    });
  }

  /** Función para subir documentos `brochure` */
  pondHandleAddFile(event: any, type: 'brochure') {
    if(!event.error) {
      if(type === 'brochure') {
        const file = this.pondBrochure.getFile().file;
        this.brochureTmpFile = file;
      }
    }
  }

  /** Función para eliminar el documento adjunto del brochure */
  deleteFile(type: 'brochure') {
    if(type === 'brochure') {
      this.brochureTmpFile = null;
    }
  }

  validForm() {
    return (!(this.firstFormDev.valid));
  }

  nextStep() {

    const requests: { info?: any, brochure?: any } = {};
    const recolectInfo = this.firstFormDev.value;

    // Subir documento `brochure`
    if(!this.brochureFile && this.brochureTmpFile) {
      requests.brochure = this.devServ.uploadDocuments(this.brochureTmpFile, 'brochure').pipe(tap(res => this.brochureFile = this.brochureTmpFile.name));
    }

    // Enviar información
    requests.info = this.devServ.updateInfoDevStepZero(recolectInfo, this.email);

    forkJoin(requests).subscribe((r: { info?: any, brochure?: any }) => {
      if(r) {
        const modal = this.modalServ.modalCustom({
          header: 'Información actualizada',
          img: 'https://static.monific.com/assets/assets-app/img/icon/img/reg-success.svg',
          title: '¡Bienvenido a Monific!',
          message: `Gracias por elegirnos, en breve nos pondremos en contacto con usted. <br><br> ¿Deseas continuar con tu registro?`,
          buttonText: 'Continuar',
          cancelText: 'Terminar más tarde'
        });

        modal.beforeClosed().subscribe(r => {
          if(r) {
            this.form.next(r);
          } else {
            this.devServ.updateRegStep(2).subscribe(r => {
              if(r) {
                this.router.navigate([PATH.ROUTE_DEVELOPER]);
              } else {
                this.toastServ.warning('No fue posible actualizar tu información');
              }
            })
          }
        })

      } else {
        this.toastServ.warning('No fue posible actualizar tu información');
      }
    })

  }
}
